// Supplier KYC — the business verification Grow runs before a supplier may
// trade inside a community. It runs in two beats: the supplier fills in Grow's
// own form (ours only hosts it), and then Grow verifies what was sent. Until
// both are done the supplier can build their business here — items, price
// lists, settings — but stays invisible to communities.
//
// The backend serves this on the sidebar payload as `kyc_status`; the client
// only ever reads it.

export const KYC_STATUS = {
  /** Registered, but Grow's form hasn't been filled in yet. Where everyone starts. */
  DETAILS_REQUIRED: "DETAILS_REQUIRED",
  /** Submitted to Grow, waiting on their verdict. */
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

/**
 * True while the supplier may not reach a community: ask to join, send an
 * offer, or answer an invitation.
 *
 * Only an explicit non-approved status blocks. A missing status means a
 * payload that doesn't carry the field yet (this FE ships before the backend
 * half), and must not lock working suppliers out of the app — the real gate is
 * the server rejecting these calls, not this function.
 */
export const isKycBlocked = (status) =>
  status === KYC_STATUS.DETAILS_REQUIRED ||
  status === KYC_STATUS.PENDING ||
  status === KYC_STATUS.REJECTED;

/** True when there is something to show the supplier about their KYC. */
export const hasKycNotice = (status) => isKycBlocked(status);

/** The one state where the supplier has something to DO about it. */
export const needsKycDetails = (status) =>
  status === KYC_STATUS.DETAILS_REQUIRED;
